import type { UserType } from '../../types';

export interface AnalyticsTraits {
  email: string | undefined;
  domain: string | undefined;
  tenant: number | undefined;
  role: string | undefined;
}

/**
 * Segment user traits for the current user.
 *
 * These belong on `identify`, never on individual events: Amplitude builds
 * cohorts from user properties, so attaching them per-event makes them
 * unusable for reporting (CPF-1199). `domain` is what makes "HG employees vs
 * customers" reportable.
 */
export function getAnalyticsTraits(
  user: UserType,
  tenantId: number | undefined
): AnalyticsTraits {
  const { email } = user;

  return {
    email,
    domain: email ? email.split('@')[1] : undefined,
    tenant: tenantId,
    // v2 tenants carry the role on `rbac`; on v1 `model_session.update_user`
    // has already resolved `user.role` from the permission for this tenant.
    role: user.rbac?.role || user.role,
  };
}
